export const columnsTypificationsByHour = [
  {
    dataIndex: "user_full_name",
    key: "user_full_name",
    width: 120,
    slots: { title: "userTitle" },
    sorter: (a, b) => {
      if (a.user_full_name.toLowerCase() < b.user_full_name.toLowerCase()) return -1;
      if (a.user_full_name.toLowerCase() > b.user_full_name.toLowerCase()) return 1;
      return 0;
    },
  },
  {
    dataIndex: "hour_management",
    key: "hour_management",
    width: 80,
    slots: { title: "hourTitle", customRender: "hourManagement" },
    sorter: (a, b) => {
      if (a.hour_management < b.hour_management) return -1;
      if (a.hour_management > b.hour_management) return 1;
      return 0;
    },
  },
  {
    title: "Contacto directo",
    dataIndex: "direct_contact",
    key: "direct_contact",
    width: 120,
  },
  {
    title: "Contacto indirecto",
    dataIndex: "indirect_contact",
    key: "indirect_contact",
    width: 120,
  },
  {
    title: "No contacto",
    dataIndex: "no_contact",
    key: "no_contact",
    width: 120,
  },
  {
    title: "Total gestiones",
    dataIndex: "total_managements",
    key: "total_managements",
    width: 120,
  },
  {
    title: "Número de PDP",
    dataIndex: "total_pdp",
    key: "total_pdp",
    width: 120,
  },
  {
    title: "Monto total de PDP",
    dataIndex: "amount_pdp",
    key: "amount_pdp",
    width: 120,
  },
];

export const columns = [
  {
    title: "Fecha",
    dataIndex: "date",
    slots: { customRender: "date" },
    key: "date",
    width: 120,
  },
  {
    title: "Hora",
    dataIndex: "hour",
    slots: { customRender: "hour" },
    key: "hour",
    width: 80,
  },
  {
    title: "Número de documento",
    dataIndex: "contact_data",
    key: "document",
    width: 200,
  },
  {
    title: "Contacto",
    dataIndex: "contact_data",
    key: "contactName",
    width: 150,
  },
  {
    title: "Codigo de contacto",
    dataIndex: "contact_data",
    key: "contactCode",
    width: 200,
  },
  {
    title: "Teléfono",
    dataIndex: "phone",
    key: "phone",
    width: 120,
  },
  {
    title: "Fecha de PDP",
    dataIndex: "date_promise_to_pay",
    key: "date_promise_to_pay",
    width: 120,
  },
  {
    title: "Monto de PDP",
    dataIndex: "amount_promise_to_pay",
    key: "amount_promise_to_pay",
    width: 120,
  },
  {
    title: "Usuario",
    dataIndex: "user",
    key: "user",
    width: 150,
  },
  {
    title: "Anexo",
    dataIndex: ["user", "annex"],
    key: "user.annex",
    width: 80,
  },
  {
    title: "Tipo de contacto",
    dataIndex: "type_contact",
    key: "type_contact",
    width: 180,
  },
  {
    title: "Resultado",
    dataIndex: "result",
    key: "result",
    width: 120,
  },
  {
    title: "Motivo",
    dataIndex: "motive",
    key: "motive",
    width: 120,
  },
  {
    title: "Submotivo",
    dataIndex: "submotive",
    key: "submotive",
    width: 120,
  },
  {
    title: "Comentario de tipificacion",
    dataIndex: "comment",
    key: "comment",
    width: 200,
  },
  {
    title: "Empresa",
    dataIndex: "entity",
    key: "entity",
    width: 120,
  },
  {
    title: "Campaña",
    dataIndex: "portfolio",
    key: "portfolio",
    width: 120,
  },
  {
    title: "Base",
    dataIndex: "base",
    key: "base",
    width: 120,
  },
];

export const columnsReportSeven = [
  {
    title: "Fecha de tipificación",
    dataIndex: "date",
    slots: { customRender: "date" },
    key: "date",
    width: 180,
  },
  {
    title: "Hora de tipificación",
    dataIndex: "hour",
    slots: { customRender: "hour" },
    key: "hour",
    width: 180,
  },
  {
    title: "Número de documento",
    dataIndex: "contact_data",
    key: "document",
    width: 200,
  },
  {
    title: "Contacto",
    dataIndex: "contact_data",
    key: "contactName",
    width: 150,
  },
  {
    title: "Codigo de contacto",
    dataIndex: "contact_data",
    key: "contactCode",
    width: 200,
  },
  {
    title: "Teléfono",
    dataIndex: "phone",
    key: "phone",
    width: 120,
  },
  {
    title: "Código de producto",
    dataIndex: "account",
    key: "account",
    slots: { customRender: "account" },
    width: 200,
  },
  {
    title: "Tipo de PDP",
    dataIndex: "pdp_type",
    key: "pdp_type",
    slots: { customRender: "pdpType" },
    width: 120,
  },
  {
    title: "Fecha de PDP",
    dataIndex: "date_promise_to_pay",
    key: "date_promise_to_pay",
    width: 120,
  },
  {
    title: "Monto de PDP",
    dataIndex: "amount_promise_to_pay",
    key: "amount_promise_to_pay",
    width: 120,
  },
  {
    title: "Usuario",
    dataIndex: ["user", "name"],
    key: "user.name",
    slots: { customRender: "customNameEmpty" },
    width: 150,
  },
  {
    title: "Anexo",
    dataIndex: ["user", "annex"],
    key: "user.annex",
    slots: { customRender: "customAnnexEmpty" },
    width: 80,
  },
  {
    title: "Tipo de contacto",
    dataIndex: "type_contact",
    key: "type_contact",
    width: 180,
  },
  {
    title: "Resultado",
    dataIndex: "result",
    key: "result",
    width: 120,
  },
  {
    title: "Motivo",
    dataIndex: "motive",
    key: "motive",
    width: 120,
  },
  {
    title: "Submotivo",
    dataIndex: "submotive",
    key: "submotive",
    slots: { customRender: "customSubmotiveEmpty" },
    width: 120,
  },
  {
    title: "Comentario de tipificacion",
    dataIndex: "comment",
    key: "comment",
    width: 200,
  },
  {
    title: "Empresa",
    dataIndex: "entity",
    key: "entity",
    width: 120,
  },
  {
    title: "Campaña",
    dataIndex: "portfolio",
    key: "portfolio",
    width: 120,
  },
  {
    title: "Base",
    dataIndex: "base",
    key: "base",
    width: 120,
  },
];

export const columnsCallsAnswered = [
  {
    title: "Nombre del usuario",
    dataIndex: "user_full_name",
    slots: { customRender: "user_full_name" },
    key: "user_full_name",
    width: 220,
    fixed: "left",
  },
  {
    title: "Total",
    dataIndex: "total",
    slots: { customRender: "total" },
    key: "total",
    width: 80,
    fixed: "left",
  },
];

export const columnsIncomingPerAgent = [
  {
    title: "Nombre del usuario",
    dataIndex: "user_full_name",
    slots: { customRender: "user_full_name" },
    key: "user_full_name",
    //width: 80,
    fixed: "left",
  },
  {
    title: "Total",
    dataIndex: "total",
    slots: { customRender: "total" },
    key: "total",
    width: 104,
    fixed: "left",
  },
  {
    title: "Telefonía atendidas",
    dataIndex: "answered",
    slots: { customRender: "answered" },
    key: "answered",
    //width: 80,
    //fixed: "left",
  },
  {
    title: "Telefonía no atendidas",
    dataIndex: "not_answered",
    slots: { customRender: "not_answered" },
    key: "not_answered",
    //width: 80,
    //fixed: "left",
  },
    {
    title: "WhatsApp Voice atendidas",
    dataIndex: "answered_whatsapp_voice",
    slots: { customRender: "answered_whatsapp_voice" },
    key: "answered_whatsapp_voice",
    //width: 80,
    //fixed: "left",
  },
  {
    title: "WhatsApp Voice no atendidas",
    dataIndex: "not_answered_whatsapp_voice",
    slots: { customRender: "not_answered_whatsapp_voice" },
    key: "not_answered_whatsapp_voice",
    //width: 80,
    //fixed: "left",
  },
];